import { render, staticRenderFns } from "./update-password.vue?vue&type=template&id=c10b894c&scoped=true&"
import script from "./update-password.vue?vue&type=script&lang=js&"
export * from "./update-password.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c10b894c",
  null
  
)

export default component.exports